enum ComponentColor {
  blue = 'blue',
  orange = 'orange',
  purple = 'purple',
  darkBlue = 'darkBlue',
}

export default ComponentColor
